const Window: any = window;

export abstract class BaseUrls {
  protected baseUrl: string;
  protected legacyUrl: string;
  protected studentApiUrl: string;

  constructor() {
        this.baseUrl = window.APP_CONFIG.TEACHER_SERVICE;
        this.legacyUrl = window.APP_CONFIG.BACKEND_HOST;
        this.studentApiUrl = window.APP_CONFIG.STUDENT_SERVICE;
  }
}
